<div class="flex bubble-row">
  @if(this.message.role == "user"){
  <div class="flex-1"></div>
  }
  <div class="flex-4 bubble bubble-{{this.message.role}}">
    <markdown
      [data]="this.message.content.replaceAll('\n', '<br>')"
      [disableSanitizer]="true"
      (ready)="this.renderButtons()"
    />
  </div>
  @if(this.message.role == "assistant"){
  <div class="flex-1"></div>
  }
</div>


<ng-template
  #btn
  let-teilaufgabenindex="teilaufgabenindex"
>
  <p-button
    class="ms-3 chat-edit-button-host"
    styleClass="chat-edit-button"
    label="Tabelle ausfüllen"
    icon="pi pi-table"
    size="small"
    severity="info"
    [raised]="true"
    (onClick)="this.chatService.selectedTeilaufgabeTable = teilaufgabenindex"
  />
</ng-template>